import { useRedirectToMessagesHook } from './useRedirectToMessagesHook';
import { UnleashService } from '../../../services';
import useUnleashHook from '../../../core/unleash/useUnleashHook'

const MessagingRedirect = (props) => {
  const enableFeedsHook = useUnleashHook(UnleashService.FLAGS.ENABLE_FEEDS);
  const enableFeeds = enableFeedsHook.isFlagEnabled();
  useRedirectToMessagesHook({ ...props, enableFeeds });
  return null;
};

export default MessagingRedirect;
